import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { MultiAgencyService } from 'app/shared/multi-agency/multi-agency.service';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { OnyxEvent } from '../models/event';
import { EventStore } from '../service/event.store';
import { InvoiceHistoryStore } from '../service/invoice-history.store';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'pioneer-invoice-history',
  templateUrl: './invoice-history.component.html',
  styleUrls: ['./invoice-history.component.css']
})
export class InvoiceHistoryComponent implements OnInit, OnDestroy {

  private userUrl = '/secure/invoice-history/user';

  @Input() auth: string;

  invoiceUrl: string;

  defaultAgency$: Observable<MultiAgency> = this.multiAgencyService.defaultAgency$;
  private _destroyed$: Subject<void> = new Subject<void>();

  constructor(
    private environment: EnvironmentConfiguration,
    private invoiceHistoryStore: InvoiceHistoryStore,
    private eventStore: EventStore,
    private authenticationStore: AuthenticationStore,
    private multiAgencyService: MultiAgencyService) { }

  ngOnInit() {
    this.invoiceUrl = this.getDefaultUrl();

    if (this.auth) {
      this.invoiceUrl = this.invoiceUrl + '&authorization=' + this.auth;
    } else {
      this.defaultAgency$.pipe(
        takeUntil(this._destroyed$),
        switchMap((agency: MultiAgency) => {
          return this.eventStore.selectedEvent;
        }),
        switchMap((event: OnyxEvent) => {
          if (!event || !event.eventId) {
            this.invoiceUrl = this.getDefaultUserUrl();
          }
          return this.getInvoiceHistory(event);
        }),
        tap((token: any) => {
          this.invoiceUrl = this.invoiceUrl + '&authorization=' + token;
        })
      ).subscribe();
    }
  }

  private getInvoiceHistory(event: OnyxEvent) {
    let invoiceHistoryAuth$: Observable<any>;
    if (event && event.eventId) {
      if (this.authenticationStore.isAgencyUser()) {
        invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryEventAgencyAuth(event.eventId);
      } else {
        invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryEventPropertyAuth(event.eventId);
      }
    } else {
      if (this.authenticationStore.isAgencyUser()) {
        invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryAgencyAuth();
      } else {
        invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryPropertyAuth();
      }
    }
    return invoiceHistoryAuth$;
  }

  private getDefaultUrl(): string {
    return this.environment.invoiceHistoryUrl + '?dt=' + this.getRandomNumber();
  }

  private getDefaultUserUrl(): string {
    return this.environment.invoiceHistoryUrl + this.userUrl + '?dt=' + this.getRandomNumber();
  }

  private getRandomNumber(): number {
    return Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history/invoice-history.component.ts